import * as React from 'react';
import { createSvgIcon } from '@fluentui/react-icons-mdl2';

const ClassNotebookLogoFill16Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1728 320h256v1408h-256v128h-640v-237l-320-18-263-465v451l-329-19V480l319-18 254 443V447l339-19V192h640v128z" />
    </svg>
  ),
  displayName: 'ClassNotebookLogoFill16Icon',
});

export default ClassNotebookLogoFill16Icon;
